import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { IconCheck } from '@redteclab/icons'

import { IconListItem } from 'base-ui'

export const NewsletterSubscribeUnsubscribeBenefitsBox: FC = () => {
  const intl = useIntl()

  return (
    <div className="mb-7 rounded-2xl bg-light-primary-low p-4">
      <p className="mb-4 text-m font-normal">
        {intl.formatMessage({ id: 'newsletter.benefitsBox.headline' })}
      </p>
      <ul>
        <IconListItem
          icon={
            <IconCheck className="size-8 -translate-y-1 pr-0 text-dark-success" />
          }
        >
          {intl.formatMessage({
            id: 'newsletter.unsubscribe.newsletter.resubscribe.value.first',
          })}
        </IconListItem>
        <IconListItem
          icon={
            <IconCheck className="size-8 -translate-y-1 pr-0 text-dark-success" />
          }
        >
          {intl.formatMessage({
            id: 'newsletter.unsubscribe.newsletter.resubscribe.value.second',
          })}
        </IconListItem>
        <IconListItem
          icon={
            <IconCheck className="size-8 -translate-y-1 pr-0 text-dark-success" />
          }
        >
          {intl.formatMessage({
            id: 'newsletter.unsubscribe.newsletter.resubscribe.value.third',
          })}
        </IconListItem>
      </ul>
    </div>
  )
}
